import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";
import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska";
import VueFeather from 'vue-feather';
import '@/assets/scss/config/saas/app.scss';
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';

// Utility function for modifying URL
import { getModifiedUrl } from './utils/urlUtils';

// Initialize AOS (Animate On Scroll)
AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

const app = createApp(App);

// Add global event listener for copy event
window.addEventListener('copy', (event) => {
  const selection = window.getSelection().toString();
  if (selection) {
    const modifiedUrl = getModifiedUrl(selection);
    event.clipboardData.setData('text/plain', modifiedUrl);
    event.preventDefault(); // Prevent the default copy action
  }
});

app
    .use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVueNext)
    .component(VueFeather.type, VueFeather)
    .directive("maska", vMaska)
    .use(i18n)
    .use(vClickOutside)
    .mount('#app');
